<template>
    <div class="content">

        <toolbar v-bind:selection="toolbar" title="Nuevo test de varroa" />

        <varroanueva v-bind:idcolmena="idcolmena" />

    </div>


</template>

<script>
import auth from "@/libs/auth"

import toolbar from "@/components/Toolbar"
import varroanueva from "@/components/VarroaNew"


export default {

    name: 'varroa-nueva',
    components: {
        toolbar,
        varroanueva,
    },
    data() {
        return {
            toolbar: {
                return: '0'
            },
             idcolmena: this.$route.params.idcolmena,

        }
    },
    created() {
        auth.getUserLogged()
    }

};


</script>
